class SearchModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");

    this.detailsContainer.addEventListener(
      "keyup",
      (event) =>
        event.code && event.code.toUpperCase() === "ESCAPE" && this.close()
    );
    this.summaryToggle.addEventListener(
      "click",
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      "click",
      this.close.bind(this)
    );
    this.querySelector('button[type="reset"]').addEventListener(
      "click",
      this.reset.bind(this)
    );

    this.summaryToggle.setAttribute("role", "button");

    this.updateMobileClass();
    window.addEventListener("resize", this.updateMobileClass.bind(this));
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest("details").hasAttribute("open")
      ? this.close()
      : this.open(event);
  }

  updateMobileClass() {
    if (window.innerWidth <= 425) {
      this.classList.add("search-modal__mobile");
    } else {
      this.classList.remove("search-modal__mobile");
    }
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains("modal-overlay")
    )
      this.close();
  }
  open() {
    setScrollbarWidth();
    setHeaderBottomPosition();

    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);

    this.detailsContainer.setAttribute("open", true);
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("search-modal--open");

    trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        this.detailsContainer.querySelector('input:not([type="hidden"])')
    );

   
    if (window.innerWidth >= 3000 ) {
        let searchField = this.querySelector(".search-modal__form .field");
        let modalContent = this.querySelector(".modal__content");
        let searchContainerSummary = this.querySelector(".search-container summary");

        if (searchField) {
            searchField.style.width = "25%";
            searchField.style.borderRadius = "50px";
            searchField.style.border = "1px solid green";
            searchField.style.position = "absolute";
            searchField.style.right = "27%";  
            searchField.style.display = "flex"; 
            searchField.style.opacity = "1";
            searchField.style.transition = "opacity 0.3s ease-in-out"; 
            searchField.style.marginTop = "20px";
        }

        if (modalContent) {
            modalContent.style.background = "none";
        }

        if (searchContainerSummary) {
            searchContainerSummary.style.display = "none"; // Hide summary when search is open
        }
    }
}


  close() {
    // uncomment the below code and remove const summary and if (summary) block if some issue take place
    // this.querySelector(".search-container summary").style.display = "block";
    const summary =this.querySelector(".search-container summary") || this.summaryToggle;
    if (summary) summary.style.display = "block";
    removeTrapFocus();
    this.detailsContainer.removeAttribute("open");
    document.body.removeEventListener("click", this.onBodyClickEvent);
    document.body.classList.remove("search-modal--open");
    document.dispatchEvent(new CustomEvent("searchmodal:close"));
  }

  reset(event) {
    event.preventDefault();
    this.querySelector('input[type="search"]').value = "";
  }
}

customElements.define("search-modal", SearchModal);
